import React, { ReactElement } from "react";
import { BiPlayCircle } from "react-icons/bi";
import { StepProps } from "./base";

export default function OnboardingStep(props: StepProps): ReactElement {
    return (
        <div>
            <h2>How do you want to be contacted?</h2>
            <p>
                How do you want people to create requests? Just by typing a message in a channel,
                using emoji&apos;s, or using the channel menu? You can also mix and match modes.
            </p>

            <div className="d-flex list-group flex-row w-100 gap-2">
                <div className="text-center d-flex flex-column">
                    <button type="button" className="list-group-item list-group-item-action flex-grow-1 p-3 rounded ">
                        <strong>Threaded</strong>
                        <p>
                            When a user types a message in a channel, Foqal creates a thread and responds automatically.
                        </p>
                    </button>

                    <button type="button" className="btn btn-none d-block mx-auto mt-2">
                        <BiPlayCircle />
                        {" "}
                        Explain Threaded
                    </button>

                </div>
                <div className="text-center d-flex flex-column">
                    <button type="button" className="list-group-item list-group-item-action flex-grow-1 p-3 rounded ">
                        <strong>Emoji</strong>
                        <p>
                            Would you prefer to use an emoji to manually convert a Slack message or thread into a ticket.
                        </p>
                    </button>
                    <button type="button" className="btn btn-none d-block mx-auto mt-2">
                        <BiPlayCircle />
                        {" "}
                        Explain Emoji
                    </button>
                </div>
                <div className="text-center d-flex flex-column">
                    <button type="button" className="list-group-item list-group-item-action flex-grow-1 p-3 rounded ">
                        <strong>Channel Menu</strong>
                        <p>
                            The Channel Menu sticks to the bottom of the Slack channel and allows users to create
                            requests from forms.
                        </p>
                    </button>
                    <button type="button" className="btn btn-none d-block mx-auto mt-2">
                        <BiPlayCircle />
                        {" "}
                        Explain Channel Menu
                    </button>
                </div>
            </div>

        </div>
    );
}
